import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import OpenAICalc from '../components/calculators/OpenAICalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function OpenAIPage() {
  return (
    <>
      <Helmet>
        <title>Azure OpenAI Cost Calculator UK | GPT-4o · PTU vs PAYG | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure OpenAI costs in GBP. Compare Standard PAYG (per-token) vs Provisioned Throughput Units (PTU) for GPT-4o, GPT-4o mini, o3-mini, and GPT-4. Includes PTU break-even analysis." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/azure-openai" />
        <meta property="og:title" content="Azure OpenAI Cost Calculator UK — GPT-4o, PTU vs PAYG" />
        <meta property="og:description" content="GBP pricing for Azure OpenAI. GPT-4o, GPT-4o mini, o3-mini token rates. PTU break-even analysis — find out if Provisioned Throughput Units save you money." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/azure-openai" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Azure OpenAI Calculator', url: '/azure-openai', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure OpenAI Cost Calculator',
          description: 'Independent Azure OpenAI pricing calculator — GPT-4o Standard PAYG vs PTU break-even analysis in GBP.',
          url: 'https://www.azure-calc.co.uk/azure-openai',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure OpenAI Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            GBP pricing · GPT-4o · Standard PAYG vs PTU break-even · AI Foundry
          </p>
        </div>

        <OpenAICalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>Related guides</h2>
          <Link
            to="/guides/azure-openai-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure OpenAI Pricing Guide UK</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Token pricing, PTU break-even, model comparison, and how to estimate your usage before deploying</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
